import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from 'gatsby'

export default function PostListItem({ post, location }) {
  return (
    <>
      { 
        post ? (
          <Link
            to={`/posts/` + post.postId}
            state={{
              from: location?.pathname
            }}
          >
            <figure>
            <GatsbyImage image={getImage(post.thumbnailSquare.src)} alt={post.title} />
            </figure>
            <div className="description">
              { 
                post.categoryName ? (
                  <>
                    <span className="category">エルメス</span>
                    <span>/</span>
                  </>
                ) : ''
              }
              <span className="date">{post.postedAt.substr(0, 10).replace(/-/g, '/')}</span>
              <p className="title">{post.title}</p>
            </div>
          </Link>
        ) : ''
      }
    </>
  )
}

